import React, { useEffect, useState } from 'react';
import {
	getTotalSalesForAllAgents,
	getTotalSalesForCurrentAgent,
} from '../../../api/Dashboard/getTotalSales.api';
import CountUp from 'react-countup';
import styles from './TotalSales.module.scss';

//material ui
import { Card } from '@material-ui/core';
import CardContent from '@material-ui/core/CardContent';
import TotalSalesChart from './chart/TotalSalesChart';
import { shortenNumbers } from '../../../utils/shortenNumbers';

const TotalSales = ({ salesAgentId, filterByDate }) => {
	const [totalSalesForCurrentAgent, setTotalSalesForCurrentAgent] =
		useState(0);
	const [totalSalesForAllAgents, setTotalSalesForAllAgents] = useState(0);
	const [totalSales, setTotalSales] = useState(0);

	useEffect(() => {
		if (salesAgentId && salesAgentId !== 'allSalesAgents') {
			getTotalSalesForCurrentAgent(
				salesAgentId,
				filterByDate,
				(returned) => {
					setTotalSalesForCurrentAgent(returned);
					console.log('salesData', returned);
				}
			);
		} else if (salesAgentId === 'allSalesAgents') {
			getTotalSalesForAllAgents(filterByDate, (returned) => {
				setTotalSalesForAllAgents(returned);
				console.log('salesData', returned);
			});
		}
	}, [salesAgentId, filterByDate]);

	return (
		<>
			<Card className={styles.total_sales_card_group} variant='outlined'>
				<CardContent>
					<h3>Total Sales</h3>
					{salesAgentId === 'allSalesAgents' ? (
						<>
							<div className={styles.card_text_content}>
								$
								{shortenNumbers(
									totalSalesForAllAgents?.totalSales,
									1
								)}
							</div>
							<TotalSalesChart
								salesData={totalSalesForAllAgents?.salesArr}
								timesData={totalSalesForAllAgents?.timeArr}
								netSalesData={
									totalSalesForAllAgents?.totalNetSales
								}
							/>
						</>
					) : (
						<>
							<div className={styles.card_text_content}>
								$
								{shortenNumbers(
									totalSalesForCurrentAgent?.totalSales,
									1
								)}
							</div>
							<TotalSalesChart
								salesData={totalSalesForCurrentAgent?.salesArr}
								timesData={totalSalesForCurrentAgent?.timeArr}
								netSalesData={
									totalSalesForCurrentAgent?.totalNetSales
								}
							/>
						</>
					)}
				</CardContent>
			</Card>
		</>
	);
};

export default TotalSales;
